import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'cx_foundations-order_list_page_issue_unrelated_button-click';

/**
 * Event that tracks the "My issue is unrelated to this order" button clicks on the orders list page for self-service
 */
export function trackCxFoundationsOrderListPageIssueUnrelatedButtonClick(
  retailerbrand_token: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { retailerbrand_token },
  });
}
